import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  fetchSite,
  SiteApiItem,
} from "../../site-listings/services/siteListingConfig";
import { fetchSEOConfigs, SEOConfigApiItem } from "../services/seoConfig";

export const useWebsiteSeoData = (siteId: number) => {
  const [site, setSite] = useState<SiteApiItem | null>(null);
  const [configs, setConfigs] = useState<SEOConfigApiItem[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!Number.isFinite(siteId)) return;
    setLoading(true);
    try {
      const [siteResponse, seoResponse] = await Promise.all([
        fetchSite(siteId),
        fetchSEOConfigs(siteId),
      ]);
      setSite(siteResponse.data);
      setConfigs(seoResponse.data.results || []);
    } catch (error) {
      console.error("Failed to load website SEO", error);
      toast.error("Failed to load this website's SEO pages");
    } finally {
      setLoading(false);
    }
  }, [siteId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { site, configs, loading, reload };
};
